import React, { useState, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import { FaCalendarAlt } from 'react-icons/fa';
import API from '../../../services/api';

const ActivityCalendar = ({ studentId }) => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadActivities();
  }, [currentDate]);

  const loadActivities = async () => {
    try {
      setLoading(true);
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth() + 1;
      const response = await API.get(`/student/${studentId}/activity?year=${year}&month=${month}`);
      setActivities(response.data.data || []);
    } catch (error) {
      console.error('Failed to load activities:', error);
    } finally {
      setLoading(false);
    }
  };

  const getDaysInMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  };

  const getFirstDayOfMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth(), 1).getDay();
  };

  const isActiveDay = (date) => {
    const dateStr = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${String(date).padStart(2, '0')}`;
    return activities.some(a => a.activity_date === dateStr);
  };

  const isToday = (date) => {
    const today = new Date();
    return date === today.getDate() && 
           currentDate.getMonth() === today.getMonth() && 
           currentDate.getFullYear() === today.getFullYear();
  };

  const changeMonth = (increment) => {
    const newDate = new Date(currentDate);
    newDate.setMonth(currentDate.getMonth() + increment);
    setCurrentDate(newDate);
  };

  const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const weekDays = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
  
  const daysInMonth = getDaysInMonth(currentDate);
  const firstDay = getFirstDayOfMonth(currentDate);
  const days = [];

  for (let i = 0; i < firstDay; i++) {
    days.push(null);
  }
  for (let i = 1; i <= daysInMonth; i++) {
    days.push(i);
  }

  return (
    <Card className="activity-calendar-card h-100">
      <Card.Body>
        <div className="calendar-header">
          <button onClick={() => changeMonth(-1)} className="calendar-nav">‹</button>
          <h5 className="calendar-title">
            <FaCalendarAlt className="me-2 text-primary" />
            {monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}
          </h5>
          <button onClick={() => changeMonth(1)} className="calendar-nav">›</button>
        </div>
        
        <div className="calendar-weekdays">
          {weekDays.map(day => (
            <div key={day} className="weekday">{day}</div>
          ))}
        </div>
        
        <div className="calendar-days">
          {days.map((day, index) => (
            <div 
              key={index} 
              className={`calendar-day ${day ? (isActiveDay(day) ? 'active' : 'inactive') : 'empty'} ${isToday(day) ? 'today' : ''}`}
            >
              {day}
            </div>
          ))}
        </div>
        
        <div className="calendar-legend mt-3">
          <div className="legend-item">
            <span className="legend-color active"></span>
            <span>Active Day</span>
          </div>
          <div className="legend-item">
            <span className="legend-color inactive"></span>
            <span>Inactive Day</span>
          </div>
          <div className="legend-item">
            <span className="legend-color today"></span>
            <span>Today</span>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ActivityCalendar;